import * as $ from 'jquery';
import { DefaultService } from '../../common/services/DefaultService';
import { apiBaseUrlUser } from '../../../constants/url.constant';

export class StateService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/state`;

    public RouteGetList = () => `${this.baseUrl}/getList`;
    public getList(): JQueryPromise<any> {
        return $.ajax(this.RouteGetList(), {
            type: 'get',
            contentType: 'application/json'
        });
    }
}